import React from 'react';
import PageList from '../../../components/PageListAPI'
import { getRemovalStorageMaterial, deleteRemovalStorageMaterial } from '../../../api/storage'
import { ENUM_TYPE_REMOVAL } from './removalPMaterial.const'
import { useCan } from '../../../hooks/useCan';
import { SLUGS } from '../../../enum/permissions.enum';

export default function RemovalPMaterial(props) {
  const can = useCan()
  const tableHead = [
    { id: 'id', name: '№', padding: 'checkbox' },
    { id: 'user', name: 'Создатель' },
    { id: 'dateRemoval', name: 'Дата списания', type: 'date', formatDate: 'DD.MM.YYYY' },
    { id: 'typeRemovalRus', name:'Тип списания '}
  ];
  return (
    <div className='App-paper'>
      <PageList
        name='removalStorageMaterial'
        title='Документы списания материалов'
        columns={tableHead}
        createItem={can(SLUGS.DOC.REMOVAL_P.MANAGE)}
        deleteItem={can(SLUGS.DOC.REMOVAL_P.MANAGE)}
        loadAPI={{
          querty: {
            idProject: props.match.params.idProject
          },
          request: getRemovalStorageMaterial,
          transform: (res => {
            return {
              count: res.count,
              get: res.get.map(obj => {
                return { ...obj, typeRemovalRus: ENUM_TYPE_REMOVAL.find(e=>e.value===obj.typeRemoval).label }
              })
            }
          }),
        }}
        deleteAPI={{
          path: deleteRemovalStorageMaterial.path,
          type: deleteRemovalStorageMaterial.type
        }}
        {...props}
      />
    </div>
  )
}